export enum TnxErrorContext {
  UNPROCESSABLE_ENTITY_FROM_BY = 'UNPROCESSABLE_ENTITY_FROM_BY',
  UNPROCESSABLE_ENTITY_TO_TNX = 'UNPROCESSABLE_ENTITY_TO_TNX',
  UNPROCESSABLE_ENTITY_FROM_TNX = 'UNPROCESSABLE_ENTITY_FROM_TNX',
  UNPROCESSABLE_ENTITY_TO_BY = 'UNPROCESSABLE_ENTITY_TO_BY',

  SERVICE_UNAVAILABLE_FROM_BY = 'SERVICE_UNAVAILABLE_FROM_BY',
  SERVICE_UNAVAILABLE_TO_TNX = 'SERVICE_UNAVAILABLE_TO_TNX',
  SERVICE_UNAVAILABLE_FROM_TNX = 'SERVICE_UNAVAILABLE_FROM_TNX',
  SERVICE_UNAVAILABLE_TO_BY = 'SERVICE_UNAVAILABLE_TO_BY',

  REQUEST_TIMEOUT_FROM_BY = 'REQUEST_TIMEOUT_FROM_BY',
  REQUEST_TIMEOUT_TO_TNX = 'REQUEST_TIMEOUT_TO_TNX',
  REQUEST_TIMEOUT_FROM_TNX = 'REQUEST_TIMEOUT_FROM_TNX',
  REQUEST_TIMEOUT_TO_BY = 'REQUEST_TIMEOUT_TO_BY',

  UNKNOWN_FROM_BY = 'UNKNOWN_FROM_BY',
  UNKNOWN_TO_TNX = 'UNKNOWN_TO_TNX',
  UNKNOWN_FROM_TNX = 'UNKNOWN_FROM_TNX',
  UNKNOWN_TO_BY = 'UNKNOWN_TO_BY',

  RETRY_EXCEPTION = 'RETRY_EXCEPTION',

  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

const TnxErrorContextTranslations: Record<TnxErrorContext, string> = {
  [TnxErrorContext.UNPROCESSABLE_ENTITY_FROM_BY]: 'tnx-dashboard.table.event.error-message.unprocessable-entity-from-by',
  [TnxErrorContext.UNPROCESSABLE_ENTITY_TO_TNX]: 'tnx-dashboard.table.event.error-message.unprocessable-entity-to-tnx',
  [TnxErrorContext.UNPROCESSABLE_ENTITY_FROM_TNX]: 'tnx-dashboard.table.event.error-message.unprocessable-entity-from-tnx',
  [TnxErrorContext.UNPROCESSABLE_ENTITY_TO_BY]: 'tnx-dashboard.table.event.error-message.unprocessable-entity-to-by',

  [TnxErrorContext.SERVICE_UNAVAILABLE_FROM_BY]: 'tnx-dashboard.table.event.error-message.by-sftp-service-unavailable',
  [TnxErrorContext.SERVICE_UNAVAILABLE_TO_TNX]: 'tnx-dashboard.table.event.error-message.to-tnx-service-unavailable',
  [TnxErrorContext.SERVICE_UNAVAILABLE_FROM_TNX]: 'tnx-dashboard.table.event.error-message.from-tnx-service-unavailable',
  [TnxErrorContext.SERVICE_UNAVAILABLE_TO_BY]: 'tnx-dashboard.table.event.error-message.by-service-unavailable',

  [TnxErrorContext.REQUEST_TIMEOUT_FROM_BY]: 'tnx-dashboard.table.event.error-message.by-sftp-request-timeout',
  [TnxErrorContext.REQUEST_TIMEOUT_TO_TNX]: 'tnx-dashboard.table.event.error-message.to-tnx-request-timeout',
  [TnxErrorContext.REQUEST_TIMEOUT_FROM_TNX]: 'tnx-dashboard.table.event.error-message.from-tnx-request-timeout',
  [TnxErrorContext.REQUEST_TIMEOUT_TO_BY]: 'tnx-dashboard.table.event.error-message.by-request-timeout',

  [TnxErrorContext.UNKNOWN_FROM_BY]: 'tnx-dashboard.table.event.error-message.unknown-from-by',
  [TnxErrorContext.UNKNOWN_TO_TNX]: 'tnx-dashboard.table.event.error-message.unknown-to-tnx',
  [TnxErrorContext.UNKNOWN_FROM_TNX]: 'tnx-dashboard.table.event.error-message.unknown-from-tnx',
  [TnxErrorContext.UNKNOWN_TO_BY]: 'tnx-dashboard.table.event.error-message.unknown-to-by',

  [TnxErrorContext.RETRY_EXCEPTION]: 'tnx-dashboard.table.event.error-message.retry-exception',

  [TnxErrorContext.UNKNOWN_ERROR]: 'tnx-dashboard.table.event.error-message.unknown-error'
};

export function getTnxErrorContextTranslation(status: TnxErrorContext): string {
  // Doing this check to prevent displaying uncontrolled errors
  return Object.values(TnxErrorContext).includes(status)
    ? TnxErrorContextTranslations[status]
    : TnxErrorContextTranslations[TnxErrorContext.UNKNOWN_ERROR];
}
